import { error } from "console";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { PolicyType } from "../models/PolicyType";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getPoliciTypes = async (): Promise<PolicyType[]> => {
  const response = await fetch(`${API_BASE_URL}/PolicyType/GetAll`);
  const data = await response.json();
  return data;
};

const insert = async (policyType: PolicyType) => {
  const response = await fetch(`${API_BASE_URL}/PolicyType/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(policyType),
  });

  return response;
};

const update = async (policyType: PolicyType) => {
  const response = await fetch(`${API_BASE_URL}/PolicyType/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(policyType),
  });

  return response;
};

const remove = async (policyType: PolicyType) => {
  const response = await fetch(`${API_BASE_URL}/PolicyType/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(policyType),
  });

  return response;
};

interface ClonePolicyTypeRequest {
  auditTypeIdToClone: number;
  newAuditTypeName: string;
}

const clone = async (request: ClonePolicyTypeRequest): Promise<string> => {
  try {
    const response = await axios.post<string>(
      `${API_BASE_URL}/PolicyType/Clone`,
      request
    );
    return response.data;
  } catch (error) {
    console.error("Error cloning questionary type:", error);
    throw error;
  }
};

const archive = async (policyType: PolicyType) => {
  const response = await fetch(`${API_BASE_URL}/PolicyType/Archive`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(policyType),
  });

  return response;
};

const PolicyTypeService = {
  getPoliciTypes,
  insert,
  update,
  archive,
  remove,
  clone,
};

export default PolicyTypeService;
